/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取第三方登录信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetThirdOauthUserParams {
  constructor(public openId: string, public channel?: string) {}
}

export default async function (
  params: GetThirdOauthUserParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.CuUserThirdoauth;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/third-oauth/user`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
